import { render, staticRenderFns } from "./db_admin.vue?vue&type=template&id=15dafcb1&scoped=true"
import script from "./db_admin.vue?vue&type=script&lang=js"
export * from "./db_admin.vue?vue&type=script&lang=js"
import style0 from "./db_admin.vue?vue&type=style&index=0&id=15dafcb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dafcb1",
  null
  
)

export default component.exports